import React from "react";

const footer =() => {
    return(
        <div className="footer"> 
            <h3>E-com Deshboard</h3>
        </div>
    )
}

export default footer;